import { Controller } from '@hotwired/stimulus';

// The frame around a rich page (wiki/_toolbar, right before its <div lang>):
//
//   seam  the body and the host bar (`data-topbar`) wear the colour the page
//         paints at its top edge, or go clear when it paints none (nbe's
//         paper shows through); the bar stops being sticky and scrolls away
//   dock  once the page's <h1> leaves the screen, the page's resume (short
//         name, info) slides down as the top bar — qir's
//         fun-head trick: one observer, one class
//
// jane/docs/PAGES.md. Registered as "wiki-page" by registerJane.
export default class extends Controller {
  static targets = ['dock'];

  connect() {
    const page = this.element.nextElementSibling;
    this.seam(page);
    // The colour is the theme's: the topbar's switch flips data-theme.
    this.theme = new MutationObserver(() => this.seam(page));
    this.theme.observe(document.documentElement, { attributeFilter: ['data-theme'] });
    const h1 = page.querySelector('h1');
    if (!h1) return;
    // An <h1> with no box (display:none) sits at 0,0 and never intersects:
    // that is nowhere, not scrolled away — the dock stays up off the bar.
    // Up, it is inert: Tab never lands on its link out of sight.
    this.observer = new IntersectionObserver(
      ([{ isIntersecting, boundingClientRect: r }]) =>
        (this.dockTarget.inert = this.dockTarget.classList.toggle(
          '-translate-y-full',
          isIntersecting || r.top > 0 || !r.height,
        )),
    );
    this.observer.observe(h1);
  }

  disconnect() {
    this.observer?.disconnect();
    this.theme?.disconnect();
  }

  seam(page) {
    const top = page.getBoundingClientRect().top;
    let colour = '';
    for (let node = page; node; node = [...node.children].find((c) => startsAt(c, top))) {
      const bg = getComputedStyle(node).backgroundColor;
      if (!/transparent|, 0\)$|\/ 0\)$/.test(bg)) colour = bg;
    }
    document.body.style.backgroundColor = colour;
    document.querySelectorAll('[data-topbar]').forEach((bar) =>
      Object.assign(bar.style, {
        background: colour || 'transparent',
        borderColor: 'transparent',
        boxShadow: 'none',
        backdropFilter: 'none',
        position: 'relative',
      }),
    );
  }
}

// In normal flow and starting at the page's top edge (kio's hero is a
// section inside a wrapper; an absolute blur behind it is not the colour).
const startsAt = (el, top) =>
  !['STYLE', 'SCRIPT', 'svg'].includes(el.tagName) &&
  !['absolute', 'fixed'].includes(getComputedStyle(el).position) &&
  Math.abs(el.getBoundingClientRect().top - top) < 2;
